import ApiClient from '@/api/ApiClient';
import Category from '@/api/models/Category';
import BaseService from './BaseService';

class CategoryService extends BaseService{
    #prefixUrl = 'api/category/';

    constructor() {
        super();
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Get categories
     * @returns {Array}
     */
    async all() {
        const response = await this.api.executeRequest(`/index`, {}, this.api.methods.GET);
        
        let categories = [];
        if (response.success()) {
            for (let courseData of response.getContent()) {
                categories.push(new Category(courseData));
            }
        }
        
        return categories;
    }

    /**
     * Saves categoryData by creating or updating
     * @param {Array} categoryData
     * @returns {api/models/Response}
     */
    async save(categoryData = {}) {
        const response = await this.api.executeRequest('/', categoryData, this.api.methods.POST);

        if (response.success() && response.getContent() != null) {
            const categoryObject = new Category(response.getContent());
            response.setContent(categoryObject);
        }
        
        return response;
    }

    /**
     * Removes Category
     * @param {integer} categorytId 
     * @returns {Response}
     */
    async remove(categorytId = null) {
        return await this.api.executeRequest(`/${categorytId}`, {}, this.api.methods.DELETE);
    }

    /**
     * Gets Categories of Course
     * @param {string} uuid
     * @returns {array} 
     */
    async getByCourse(uuid = null) {
        const response = await this.api.executeRequest(`/course_category/${uuid}`, {}, this.api.methods.GET);

        let categories = [];

        if (response.success()) {
            for (let categoryData of response.getContent()) {
                categories.push(new Category(categoryData));
            }
        }

        return categories;
    }
}

export default new CategoryService();
